"use client"

import { useAuth } from "@/hooks/useAuth"
import { nameToTwoLetterAbbreviation } from "@/lib/text-utils"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"
import { Power } from "lucide-react"

export function UserBlock() {
  const { user, signOut } = useAuth()

  const initials = nameToTwoLetterAbbreviation(user?.name ?? "Local Developer")
  const name = user?.name ?? "Local Developer"
  const email = user?.email ?? ""

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="default" size="icon" className="size-8 rounded-full">
          <div className="flex items-center justify-center text-xs font-semibold">{initials}</div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end" className="w-full">
        <DropdownMenuGroup>
          <DropdownMenuLabel className="flex flex-row gap-2">
            <div className="flex aspect-square size-8 items-center justify-center rounded-full bg-primary shrink-0">
              <span className="text-sm font-semibold text-primary-foreground">{initials}</span>
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight min-w-0">
              <span className="truncate font-semibold text-card-foreground">{name}</span>
              <span className="truncate text-xs text-muted-foreground">{email}</span>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuItem
            className="flex flex-row gap-2 items-left w-full cursor-pointer"
            onClick={() => signOut()}
          >
            <Power className="mx-2" />
            Logout
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
